var map = {
	"./decidim/avatar-multiuser.png": 10445,
	"./decidim/brands/facebook.svg": 6233,
	"./decidim/brands/google.svg": 21904,
	"./decidim/brands/twitter-x.svg": 94821,
	"./decidim/cc-badge.png": 14363,
	"./decidim/decidim-logo.svg": 70159,
	"./decidim/default-avatar.svg": 61699,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 97097,
	"./decidim/icons.svg": 30674,
	"./decidim/pattern.png": 9745,
	"./decidim/placeholder-card-g.svg": 20894,
	"./decidim/placeholder-card-l.svg": 11605,
	"./decidim/placeholder.jpg": 92068,
	"./decidim/remixicon.symbol.svg": 89158,
	"./decidim/vendor/social-share-button/douban.svg": 99881,
	"./decidim/vendor/social-share-button/email.svg": 41610,
	"./decidim/vendor/social-share-button/facebook.svg": 42594,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 49710,
	"./decidim/vendor/social-share-button/hacker_news.svg": 39978,
	"./decidim/vendor/social-share-button/linkedin.svg": 93144,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 68241,
	"./decidim/vendor/social-share-button/pinterest.svg": 16276,
	"./decidim/vendor/social-share-button/reddit.svg": 91726,
	"./decidim/vendor/social-share-button/telegram.svg": 61903,
	"./decidim/vendor/social-share-button/tumblr.svg": 1644,
	"./decidim/vendor/social-share-button/twitter.svg": 22815,
	"./decidim/vendor/social-share-button/vkontakte.svg": 50845,
	"./decidim/vendor/social-share-button/wechat.svg": 1120,
	"./decidim/vendor/social-share-button/whatsapp.svg": 24192,
	"./decidim/vendor/social-share-button/x.svg": 9226,
	"./decidim/vendor/social-share-button/xing.svg": 15806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6304;